const frenchMessages = {
  ra: {
    action: {
      add_filter: "Ajouter un filtre",
      add: "Ajouter",
      back: "Retourner",
      bulk_actions: "1 item selected |||| %{smart_count} items selected",
      cancel: "Annuler",
      clear_array_input: "Effacer la liste",
      clear_input_value: "Effacer la valeur",
      clone: "Cloner",
      confirm: "Confirmer",
      create: "Créer",
      create_item: "Create %{item}",
      delete: "Supprimer",
      edit: "Modifier",
      export: "Exporter",
      list: "Liste",
      refresh: "Rafraîchir",
      remove_filter: "Supprimer ce filtre",
      remove_all_filters: "Supprimer tous les filtres",
      remove: "Retirer",
      save: "Sauvegarder",
      search: "Recherche",
      select_all: "Tout sélectionner",
      select_row: "Sélectionnez cette ligne",
      show: "Voir",
      sort: "Trier",
      undo: "annuler",
      unselect: "Désélectionner",
      expand: "Développer",
      close: "Fermer",
      open_menu: "Ouvrir le menu",
      close_menu: "Fermer le menu",
      update: "Mise à jour",
      move_up: "Déplacer vers le haut",
      move_down: "Descendre",
      open: "Ouvrir",
      toggle_theme: "Basculer le thème",
      select_columns: "Colonnes",
    },
    boolean: {
      true: "Oui",
      false: "Non",
      null: " ",
    },
    page: {
      create: "Create %{name}",
      dashboard: "Tableau de bord",
      edit: "%{name} #%{id}",
      error: "Quelque chose s'est mal passé",
      list: "%{name}",
      loading: "Chargement",
      not_found: "Pas trouvé",
      show: "%{name} #%{id}",
      empty: "Pas de données disponibles",
      invite: "",
    },
    input: {
      file: {
        upload_several:
          "Déposez quelques fichiers à télécharger ou cliquez pour en sélectionner un",
        upload_single:
          "Déposez un fichier à télécharger ou cliquez pour le sélectionner.",
      },
      image: {
        upload_several:
          "Déposez quelques images à télécharger ou cliquez pour en sélectionner une.",
        upload_single:
          "Déposez une image à télécharger ou cliquez pour la sélectionner.",
      },
      references: {
        all_missing: "Impossible de trouver les données de référence.",
        many_missing:
          "Au moins une des références associées ne semble plus disponible.",
        single_missing: "La référence associée ne semble plus être disponible.",
      },
      password: {
        toggle_visible: "Masquer le mot de passe",
        toggle_hidden: "Montrer le mot de passe",
      },
    },
    message: {
      about: "À propos",
      are_you_sure: "Es-tu sûr?",
      bulk_delete_content:
        "Are you sure you want to delete this %{name}? |||| Are you sure you want to delete these %{smart_count} items?",
      bulk_delete_title: "Delete %{name} |||| Delete %{smart_count} %{name}",
      auth_error:
        "Une erreur s'est produite lors de la validation du jeton d'authentification.",
      bulk_delete_content:
        "Are you sure you want to delete this %{name}? |||| Are you sure you want to delete these %{smart_count} items?",
      bulk_delete_title: "Delete %{name} |||| Delete %{smart_count} %{name}",
      bulk_update_content:
        "Are you sure you want to update this %{name}? |||| Are you sure you want to update these %{smart_count} items?",
      bulk_update_title: "Update %{name} |||| Update %{smart_count} %{name}",
      clear_array_input: "Voulez-vous vraiment effacer toute la liste ?",
      delete_content: "Êtes-vous sûr de bien vouloir supprimer cet élément?",
      delete_title: "Delete %{name} #%{id}",
      details: "Détails",
      error:
        "Une erreur client s'est produite et votre demande n'a pas pu être traitée.",

      invalid_form:
        "Le formulaire n'est pas valide. Veuillez vérifier les erreurs",
      loading: "La page est en cours de chargement, un instant s'il vous plaît",
      no: "Non",
      not_found:
        "Soit vous avez tapé une mauvaise URL, soit vous avez suivi un mauvais lien.",
      yes: "Oui",
      unsaved_changes:
        "Certaines de vos modifications n'ont pas été enregistrées. Voulez-vous vraiment les ignorer ?",
    },
    navigation: {
      no_results: "Aucun résultat trouvé",
      no_more_results:
        "The page number %{page} is out of boundaries. Try the previous page.",
      page_out_of_boundaries: "Page number %{page} out of boundaries",
      page_out_from_end: "Impossible d'aller après la dernière page",
      page_out_from_begin: "Ne peut pas aller avant la page 1",
      page_range_info: "%{offsetBegin}-%{offsetEnd} of %{total}",
      page_rows_per_page: "Lignes par page :",
      next: "Suivant",
      prev: "Précédent",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} of more than %{offsetEnd}",
      current_page: "Page %{page}",
      page: "Go to page %{page}",
      first: "Aller à la première page",
      last: "Aller à la dernière page",
      next: "Aller à la page suivante",
      previous: "Aller à la page précédente",
      page_rows_per_page: "Lignes par page :",
      skip_nav: "Aller au contenu",
    },
    sort: {
      sort_by: "Sort by %{field} %{order}",
      ASC: "ascendant",
      DESC: "descendant",
    },
    auth: {
      auth_check_error: "Merci de vous connecter pour continuer",
      user_menu: "Profil",
      username: "Nom d'utilisateur",
      password: "Mot de passe",
      sign_in: "S'identifier",
      sign_in_error: "L'authentification a échoué, veuillez réessayer",
      logout: "Se déconnecter",
    },
    notification: {
      updated: "Element updated |||| %{smart_count} elements updated",
      created: "Elément créé",
      deleted: "Element deleted |||| %{smart_count} elements deleted",
      bad_item: "Élément incorrect",
      item_doesnt_exist: "L'élément n'existe pas",
      http_error: "Erreur de communication du serveur",
      data_provider_error:
        "erreur du fournisseur de données. Vérifiez la console pour plus de détails.",
      i18n_error:
        "Impossible de charger les traductions pour la langue spécifiée",
      canceled: "Action annulée",
      logged_out: "Votre session est terminée, veuillez vous reconnecter.",
      not_authorized: "Vous n'êtes pas autorisé à accéder à cette ressource.",
    },
    validation: {
      required: "Requis",
      minLength: "Must be %{min} characters at least",
      maxLength: "Must be %{max} characters or less",
      minValue: "Must be at least %{min}",
      maxValue: "Must be %{max} or less",
      number: "Doit être un nombre",
      email: "Doit être un email valide",
      oneOf: "Must be one of: %{options}",
      regex: "Must match a specific format (regexp): %{pattern}",
    },
    saved_queries: {
      label: "Requêtes enregistrées",
      query_name: "Nom de la requête",
      new_label: "Enregistrer la requête actuelle...",
      new_dialog_title: "Enregistrer la requête actuelle sous",
      remove_label: "Supprimer la requête enregistrée",
      remove_label_with_name: 'Remove query "%{name}"',
      remove_dialog_title: "Supprimer la requête enregistrée?",
      remove_message:
        "Voulez-vous vraiment supprimer cet élément de votre liste de requêtes enregistrées?",
      help: "Filtrez la liste et enregistrez cette requête pour plus tard",
    },
    configurable: {
      customize: "Personnaliser",
      configureMode: "Configurer cette page",
      inspector: {
        title: "Inspecteur",
        content:
          "Survolez les éléments de l'interface utilisateur de l'application pour les configurer",
        reset: "Réinitialiser les options",
        hideAll: "Cacher tout",
        showAll: "Afficher tout",
      },
      Datagrid: {
        title: "Grille de données",
        unlabeled: "Unlabeled column #%{column}",
      },
      SimpleForm: {
        title: "Former",
        unlabeled: "Unlabeled input #%{input}",
      },
      SimpleList: {
        title: "Liste",
        primaryText: "Texte principal",
        secondaryText: "Texte secondaire",
        tertiaryText: "Texte tertiaire",
      },
    },
  },
  language: {
    demoText: "texte de démonstration ici pour changer de langue",
  },
  resources: {
    sap_digital_orders: {
      fields: {
        truck_number: "Détails du camion et du chauffeur",
      },
    },

    productsmaster: {
      fields: {
        edit: "Modifier",
        updated_at: "Télécharger l'horodatage",
        image_data: "Image téléchargée",
        name: "nom",
        material_code: "Code du matériau",
        material_description: "Description du matériau",
        title: "Images du produit",

        product_name: "Nom du produit",
        product_desc: "Description du produit",
        upload_images: "Télécharger des images",
        instruction: "Instructions :",
        allowed_type:
          "Types de fichiers autorisés: Images: Image JPG, Image JPEG, Image PNG",
        max_size: "Taille maximale du fichier (total): 1 Mo",
        pixel:
          "L'image doit avoir une largeur de 345 pixels et une hauteur de 345 pixels avec une couleur de fond blanche",
        product_content:
          "L'image du contenu du produit doit avoir une largeur de 245 pixels et une hauteur de 245 pixels et doit être au centre horizontalement et verticalement",
        image_repr: "Représentation de l'image",
        list_image: "Liste des images",
        front_image: "Image avant",
        back_image: "Image arrière",
        side_image: "Image latérale",
        image_dim:
          "Veuillez sélectionner une image avec des dimensions de 345 pixels de largeur et 345 pixels de hauteur",
        img_size:
          "Veuillez sélectionner une image dont la taille est inférieure à 1 MO",
        select_image: "Veuillez sélectionner une image png, jpg ou jpeg",
        cropped_img: "Image recadrée",
        save: "Enregistrer",
        loading: "chargement",
        product_images: "Images du produit",
        product_images_edit: "Images du produit Modifier",
      },
    },
    whitelist_users: {
      fields: {
        username: "Nom",
        email: "E-mail",
        role_description: "Rôle",
        status: "État",
        created_at: "Accès créé à",
        updated_log: "Mettre à jour les journaux",
        edit: "Modifier",
        business_mail: "Courriel professionnel de l'employé",
        view: "Vue",
        whitelist_user: "Administrateurs",
        email_search: "Recherche par email..",
        name_search: "Recherche par nom..",
        status_search: "Recherche par statut..",
        enter_email: "Entrez l'e-mail avec Lafargeholcim business suite.",
        customer_service: "Service client",
        country_admin: "Administrateur du pays",
        country_super_admin: "Super administrateur du pays",
        marketing: "Marketing",
        internal_control: "Contrôle interne",
      },
    },
    terms_and_condition_list: {
      fields: {
        language_name: "Nom de la langue",
        country: "Pays",
        created_date: "date de création",
        updated_log: "Journal mis à jour",
        edit: "Modifier",
        terms: "Liste des termes et conditions",
        terms_logs: "Journaux des termes et conditions",
        terms_condition: "termes et conditions",
        save: "Enregistrer",

        instruction: "Instruction :",
        instruction_desc:
          "Veuillez copier et coller ou saisir le texte des termes et conditions et cliquer sur Enregistrer en bas.Après l'enregistrement, veuillez prendre note du spinner en haut à droite pour voir si le texte a été enregistré avec succès.Si la rotation s'est arrêtée et qu'il n'y a pas d'erreur à l'écran, alors le texte a été enregistré, sinon il y aurait un message d'erreur à l'écran.",
      },
    },
    businesses: {
      fields: {
        name: "nom",
        sap_code: "No. Compte client",
        users_count: "Utilisateurs Clickit",
        users_count_holcim: "Utilisateurs HOLCIM+",
        projects_count: "Contrats",
        is_ordering_blocked: "Commande bloquée",
        profile_details: "DÉTAILS DU PROFIL",
        orders: "COMMANDES",
        clickit_user: "Utilisateurs Clickit",
        holcim_user: "Utilisateurs HOLCIM+",
        projects: "PROJETS",
        create_user: "Créer un utilisateur",
        export: "Exporter",
        project_number: "Numéro de projet",
        project_title: "Titre",
        project_address: "Adresse",
        op_division: "Division opérationnelle",
        status: "État",
        phone: "Téléphone",
        email: "E-mail",
        role_name: "Nom du rôle",
        contract: "CONTRAT",
        contracts: "CONTRATS",
      },
    },
    users_list: {
      fields: {
        first_name: "Prénom",
        last_name: "Nom de famille",
        phone: "Téléphone",
        email: "E-mail",
        principle_name: "Nom du compte client",
        principle_id: "No. Compte client",
        role_name: "Vrai nom",
        created_at: "Créé à",
        status: "État",
      },
    },
    projects: {
      fields: {
        project_number: "Numéro de projet",
        project_title: "Titre",
        project_address: "Adresse",
        op_division: "Division opérationnelle",
        status: "État",
      },
    },
    users: {
      fields: {
        first_name: "Prénom",
        last_name: "Nom de famille",
        phone: "Téléphone",
        email: "E-mail",
        principle_name: "Nom du compte client",
        principle_id: "No. Compte client",
        role_name: "Vrai nom",
        created_at: "Créé à",
        status: "État",
        address: "adresse",
        profile_image_data: "Profil",
        is_tnc_accepted: "tnc accepté",
        is_super: "super",
        updated_at: "Mis à jour à",
        updated_by_id: " Mis à jour par",
        sold_to: "Compte client",
        business_id: "Vendu à",
        save: "Enregistrer",
        clear: "Effacer",
        export: "Exporter",
        clickit_user: "Liste d'utilisateurs",
        create_user: "Créer un utilisateur",
        user_test: "Test utilisateur",
        edit_user: "Modifier l'utilisateur",
        user_details: "Détails de l'utilisateur",
        sold_to: "Compte client",
        orders: "Ordres",
        userEntity: "Statut du mappage de l'entité utilisateur",
        tnc_accepted: "Tnc accepté à",
        tnc_rejected: "Tnc rejeté à",
        role: "Rôle",
        contract: "Contrat",
        contracts: "Contrats",
      },
    },
    sms_blasts: {
      fields: {
        purpose: "Raison",
        text: "Sms text",
        target_type: "Cible",
        created_at: "Créé à",
        sms_length: "Longueur du SMS [ex. 2 (160 caractères)]",
        targeted_businesses_count: "Nombre de vendeurs",
        number_of_messages:
          "Nombre de SMS (Nombre de SMS vendus * longueur SMS)",
        notified_businesses_count: "Nombre de SMS envoyés avec succès",
        failed_businesses: "Nombre denvois SMS échoués",
        id: "No. Compte client",
        name: "Nom du compte client",
        phone: "Numéro de téléphone du compte client",
        send_status: "État SMS",
        send_response: "Réponse SMS",
        message_purpose: "Titre du message",
        enter_purpose: "Veuillez saisir une raison",
        message_desc: "Description du message",
        enter_desc: "Veuillez entrer une description",
        char_remaining: "caractères restants",
        sms_count: "Nombre de SMS :",
        msg_sendto: "Message envoyé à",
        all_retailer: "Tous les détaillants",
        set_retailer: "Un ensemble de détaillants",
        sales_officer: "Représentants commerciaux des détaillants",
        region_retailer: "Régions de détaillants",
        customer_group: "Groupe de clients de détaillants",
        choose_officer: "Choisir un agent commercial",
        atleast_one: "Sélectionnez au moins un commercial",
        clear: "Effacer",
        choose_retailer: "Choisir un revendeur",
        atleast_one_retailer: "Sélectionnez au moins un détaillant",
        choose_region: "Choisir la région",
        atleast_one_region: "Sélectionnez au moins une région",
        choose_customer: "Choisir un groupe de clients",
        atleast_one_group: "Sélectionnez au moins un groupe",
        choose_customer_retailer: "Choisir un revendeur client",
        upload_file: "Télécharger une version",
        instruction: "Instructions: ",
        only_csv:
          "Seuls les fichiers CSV sont autorisés avec une virgule comme séparateur.",
        file_format: "Pour obtenir le format du fichier de téléchargement.",
        click_here: "Cliquez ici",
        to_download: "pour télécharger",
        csv_result: "Résultat CSV",
        retailer_found: "revendeurs trouvés,",
        retailer_unregister: "revendeurs non enregistrés.",
        total_cost: "coût total: ",
        save: "Enregistrer",
        are_you_sure: "Êtes-vous sûr de vouloir continuer ?",
        cancel: "Annuler",
        ok: "OK",
        success: "Créé avec succès",
        send_msg: "Envoyer le message",
        type: "Cible",
        from_date: "Partir de la date",
        to_date: "À ce jour",
      },
    },
    in_app_notifications: {
      fields: {
        purpose: "Raison",
        title: "Titre",
        type: "Type",
        job_status: "Progression de la notification",
        admin_name: "Nom du créateur",
        admin_email: "Courriel du créateur",
        created_at: "Créé à",
        description: "Description",
        targeted_businesses_count: "Nombre de détaillants ciblés",
        notified_businesses_count: "Nombre de commerçants notifiés",
        notification_read_count: "Nombre de revendeurs ayant lu",
        send_status_percent: "% dachèvement",
        noti_purpose: "Raison de la notification",
        enter_purpose: "Veuillez saisir une raison",
        noti_title: "Titre de la notification",
        enter_title: "Veuillez entrer un titre",
        noti_desc: "Description des notifications",
        enter_desc: "Veuillez entrer une description",
        char_remaining: "caractères restants",
        all_retailer: "Tous les détaillants",
        set_retailer: "Un ensemble de détaillants",
        send_to: "Notification envoyée à",
        sales_officer: "Représentants commerciaux des détaillants",
        region_retailer: "Régions de détaillants",
        customer_group: "Groupe de clients de détaillants",
        choose_officer: "Choisir un agent commercial",
        atleast_one: "Sélectionnez au moins un commercial",
        clear: "Effacer",
        choose_retailer: "Choisir un revendeur",
        atleast_one_retailer: "Sélectionnez au moins un détaillant",
        choose_region: "Choisir la région",
        atleast_one_region: "Sélectionnez au moins une région",
        choose_customer: "Choisir un groupe de clients",
        atleast_one_group: "Sélectionnez au moins un groupe",
        choose_customer_retailer: "Choisir un revendeur client",
        upload_file: "Télécharger une version",
        instruction: "Instructions :",
        only_csv:
          "Seuls les fichiers CSV sont autorisés avec une virgule comme séparateur.",
        file_format: "Pour obtenir le format du fichier de téléchargement.",
        click_here: "Cliquez ici",
        to_download: "pour télécharger",
        csv_result: "Résultat CSV",
        retailer_found: "revendeurs trouvés,",
        retailer_unregister: "revendeurs non enregistrés.",
        total_cost: "coût total :",
        save: "Enregistrer",
        are_you_sure: "Êtes-vous sûr de vouloir continuer ?",
        cancel: "Annuler",
        success: "Créé avec succès",
        details: "DÉTAILS",
        sold_list: "Liste des comptes clients",
        target_type: "Cible",
        uploaded_date_from: "Date téléchargée à partir de",
        uploaded_date_to: "Date téléchargée à",
      },
    },
    in_app_sold_to_list: {
      fields: {
        name: "nom",
        read_status: "Lire létat",
        notification_sent_at: "Notification envoyée à",
        send_status_percent: "Statut des notifications",
      },
    },
    send_bulk_notifications: {
      fields: {
        purpose: "Raison",
        title: "Titre",
        type: "Type",
        job_status: "Progression de la notification",
        admin_name: "Nom du créateur",
        admin_email: "Courriel du créateur",
        created_at: "Créé à",
        description: "Description",
        targeted_businesses_count: "Nombre de détaillants ciblés",
        notified_businesses_count: "Nombre de commerçants notifiés",
        notification_read_count: "Nombre de revendeurs ayant lu",
        send_status_percent: "% dachèvement",
        details: "Détails",
        sold_list: "Liste des comptes clients",
        noti_purpose: "Raison de la notification",
        enter_purpose: "Veuillez saisir une raison",
        upload_file: "Télécharger une version",
        instruction: "Instructions :",
        only_csv:
          "Seuls les fichiers CSV sont autorisés avec une virgule comme séparateur.",
        file_format: "Pour obtenir le format du fichier de téléchargement.",
        click_here: "Cliquez ici",
        to_download: "pour télécharger",
        csv_result: "Résultat CSV",
        retailer_found: "revendeurs trouvés,",
        retailer_unregister: "revendeurs non enregistrés.",
        valid_file: "rChoisissez un fichier valide",
        sold_to_id: "No. Compte client",
        name: "nom",
        title: "Titre",
        save: "Enregistrer",
        success: "Créé avec succès",
      },
    },
    bulk_notification_sold_to_list: {
      fields: {
        name: "Name",
        read_status: "Read Status",
        notification_sent_at: "Notification Sent At",
        send_status_percent: "Notification Status",
        title: "Titre",
      },
    },
    complaints: {
      fields: {
        business_name: "Nom de lentrepris",
        business_sap_code: "No. Compte client",
        user_id: "Nom dutilisateur",
        complaint_type: "Type denregistrement",
        complaint_number: "Numéro denregistrement",
        category_name: "Nom de la catégorie",
        subcategory_name: "Nom de la sous-catégorie",
        complaint_status: "Statut de lenregistrement",
        complaint_created_at: "Enregistrement créé à",
        updated_at: "Horodatage de la résolution",
        contact_us: "Contactez-nous",
        record_details: "Détails de l'enregistrement",
        ref_number: "Numéro de référence",
        created_at: "Créé à",
        customer_desc: "Message du client",
        customer_service: "Commentaire du service client",
        file_uploaded: "Fichiers téléchargés",
        no_file_uploaded: "Aucun fichier téléchargé",
        pending_files:
          "Les fichiers sélectionnés lors de la commande sont toujours en cours de modification. Veuillez revenir ici plus tard",
        customer_files: "Fichiers client téléchargés",
        customer_service_files: "Fichiers du service client téléchargés",
        are_you_sure: "Êtes-vous sûr de vouloir supprimer le fichier?",
        delete: "Supprimer",
        cancel: "Annuler",
        instruction: "Instructions :",
        allowed_type:
          "Types de fichiers autorisés : Images : Image JPEG, Image PNG, Documents : Document PDF, Document Microsoft Word (.docx), Microsoft Excel (.xlsx), Comma Separated Values (.csv), OpenOffice Document (.odf), OpenOffice Spreadsheet ( .ods)",
        max_size: "Taille maximale du fichier (total): 1 Mo",
        please_wait:
          "Veuillez patienter jusqu'à ce que les fichiers soient téléchargés car la fermeture du navigateur pendant le téléchargement fera échouer le processus de téléchargement du fichier.",
        upload_timing:
          "Les fichiers téléchargés peuvent prendre jusqu'à 5 minutes pour apparaître en fonction de leur taille.",
        upload_file: "Télécharger une version",
        file_extension_invalid: "L'extension de fichier n'est pas valide",
        file_size: "La taille du fichier est supérieure à 10 Mo",
        file_type_invalid: "Le type de fichier n'est pas valide",
        both_invalid: "La taille et le type du fichier ne sont pas valides",
        edit_record: "Modifier l'enregistrement",
      },
    },
    clickit_products: {
      fields: {
        edit: "Modifier",
        product_image: "Image téléchargée",
        product_name: "Nom du produit",
        updated_at: "Télécharger lhorodatage",
        product_master: "Nom du produit",
        upload_images: "Télécharger des images",
        instruction: "Instructions :",
        allowed_type:
          "Types de fichiers autorisés: Images: Image JPG, Image JPEG, Image PNG",
        max_size: "Taille maximale du fichier (total): 1 Mo",
        pixel:
          "L'image doit avoir une largeur de 345 pixels et une hauteur de 345 pixels avec une couleur de fond blanche",
        product_content:
          "L'image du contenu du produit doit avoir une largeur de 245 pixels et une hauteur de 245 pixels et doit être au centre horizontalement et verticalement",
        image_repr: "Représentation de l'image",
        list_image: "Liste des images",
        image_dim:
          "Veuillez sélectionner une image avec des dimensions de 345 pixels de largeur et 345 pixels de hauteur",
        img_size:
          "Veuillez sélectionner une image dont la taille est inférieure à 1 MO",
        select_image: "Veuillez sélectionner une image png, jpg ou jpeg",
        cropped_img: "Image recadrée",
        save: "Enregistrer",
        loading: "chargement",
        banner_img: "Image de la bannière",
        banner_select:
          "Veuillez sélectionner une image avec des dimensions de 750 pixels de largeur et 360 pixels de hauteur",
        product_images: "Images du produit",
        material_code: "Code matériel",
        name: "nom",
      },
    },
    dashboard_banners: {
      fields: {
        edit: "Modifier",
        created_at: "Télécharger lhorodatage",
        position: "Position",
        image_data: "Image téléchargée",
        status: "État",
        mobile_home_banner: "Bannières d'accueil mobile",
        web_home_banner: "Bannières d'accueil web",
        banner_img: "Image de la bannière",
        banner_select:
          "Veuillez sélectionner une image avec des dimensions de 750 pixels de largeur et 360 pixels de hauteur",
        banner_select_web:
          "Veuillez sélectionner une image avec des dimensions de 1071 pixels de largeur et 170 pixels de hauteur",
        img_size:
          "Veuillez sélectionner une image dont la taille est inférieure à 1 MO",
        select_image: "Veuillez sélectionner une image png, jpg ou jpeg",
        instruction: "Instructions :",
        allowed_type:
          "Types de fichiers autorisés: Images: Image JPG, Image JPEG, Image PNG",
        max_size: "Taille maximale du fichier (total): 1 Mo",
        image_dim:
          "Veuillez sélectionner une image avec des dimensions de 750 pixels de largeur et 360 pixels de hauteur",
        image_dim_web:
          "Veuillez sélectionner une image avec des dimensions de 1071 pixels de largeur et 170 pixels de hauteur",
        cropped_img: "Image recadrée",
        save: "Enregistrer",
        loading: "chargement",
        create_mobile_home_banner: "Créer une bannière mobile",
        create_web_home_banner: "Créer une bannière web",
        edit_mobile_home_banner: "Modifier la bannière mobile",
        edit_web_home_banner: "Modifier la bannière web",
      },
    },
    proof_of_payments: {
      fields: {
        created_at: "Télécharger lhorodatage",
        business_id: "No. Compte client",
        sap_digital_order_id: "Numéro de commande",
        business_name: "Nom du compte client",
        approved: "Compte crédité",
        edit: "État",
        file_url_data: "Preuve de paiement",
        download: "Télécharger",
        sold_to: "Compte client",
        clear: "Effacer",
        order_number: "Numéro de commande",
        payment: "Mode de paiement",
        save: "Enregistrer",
        upload_images: "Télécharger des image",
        mode_of_payment: "Mode de paiement",
        uploaded_date_to: "Date téléchargée à",
      },
    },
    sap_digital_app_orders: {
      fields: {
        creation_date: "Date de commande",
        business_id: "Nom du compte client",
        user_id: "'Nom d'utilisateur",
        order_number: "Numéro de commande",
        business_site: "Chantier",
        mode_of_delivery: "Mode de livraison",
        customer_order_status_desc: "Statut de la commande",
        products_manual: "(Qté commandée/Qté expédiée) Produits",
        products: "Produits (quantité commandée)",
        load_nos: "Charger nos",
        received: "Reçu",
        sap_plant: "Carrière",
        sap_plant_id: "Carrière",
        delivery_date_from: "Date prévue",
        delivery_date: "La date de livraison",
        customer_ref_number: "Bon de commande",
        contract_number: "Numéro de contact",
        truck_number: "Numéro de camion",
        driver_details: "Détails du chauffeur",
        delivery_address: "Adresse de livraison",
        sap_order_failed_message: "Commande en attente",
        special_instructions: "Instruction spécial",
        mode_of_transport: "Mode de transport",
        vehicle_type: "Type de camion",
        orderDetails: "DÉTAILS DE LA COMMANDE",
        line_items: "ÉLÉMENTS DE LIGNE",
        single_delivery: "LIVRAISONS UNIQUES",
        local_po_note: "Numéro d'achat local",
        customer_order_status: "Statut de la commande client",
        digital_order: "Commandes digitales",
        is_app_order: "Est-ce une commande d'application",
        on_hold: "En attente",
        expedition_number: "Numéro d'expédition",
        load_number: "Charger le numéro",
        product: "Produit",
        ordered_quantity: "Quantité commandée",
        create_delivery: "CRÉER UNE SEULE LIVRAISON",
        order_date_from: "Date de commande du",
        order_date_to: "Date de commande au",
        site_opening: "Heure d'ouverture de votre site",
        site_closing: "Heure de fermeture de votre site",
        area: "Dispatch",
      },
    },
    sap_digital_order_line_items: {
      fields: {
        product_master: "Nom du produit",
        material_no: "Code produit",
        quantity: "Quantité",
        input_uom_name: "UOM",
      },
    },
    sap_sdo_for_orders: {
      fields: {
        edit: "État",
        delivery_number: "Numéro de livraison",
        shipment_number: "Numéro d'expédition",
        load_number: "Numéro de chargement",
        order_status_description: "Statut",
        loading_date: "Date de chargement",
        lsd_order_no: "Bon de livraison",
        receive_full_order: "Reçu",
        received_date: "Date de réception",
        created_at: "Heure contestée",
      },
    },
    sap_digital_disputed_orders: {
      fields: {
        creation_date: "Date de commande",
        business_id: "Nom du compte client",
        user_id: "'Nom d'utilisateur",
        order_number: "Numéro de commande",
        business_site: "Chantier",
        mode_of_delivery: "Mode de livraison",
        customer_order_status_desc: "Statut de la commande",
        products_manual: "(Qté commandée/Qté expédiée) Produits",
        products: "Produits (quantité commandée)",
        load_nos: "Charger nos",
        received: "Reçu",
        sap_plant: "Carrière",
        delivery_date_from: "Date prévue",
        customer_ref_number: "Bon de commande",
        contract_number: "Numéro de contact",
        truck_number: "Numéro de camion",
        driver_details: "Détails du chauffeur",
        delivery_address: "Adresse de livraison",
        sap_order_failed_message: "Commande en attente",
        special_instructions: "Instruction spécial",
        mode_of_transport: "Mode de transport",
        vehicle_type: "Type de camion",
        is_app_order: "Est-ce une commande d'application",
        on_hold: "En attente",
        expedition_number: "Numéro d'expédition",
        load_number: "Charger le numéro",
        product: "Produit",
        ordered_quantity: "Quantité commandée",
        sap_plant_id: "Carrière",
        customer_order_status: "Statut de la commande client",
        uploaded_date_from: "Date téléchargée à partir de",
        uploaded_date_to: "Date téléchargée à",
      },
    },
    received_digital_orders: {
      fields: {
        creation_date: "Date de commande",
        business_id: "Nom du compte client",
        user_id: "'Nom d'utilisateur",
        order_number: "Numéro de commande",
        business_site: "Chantier",
        mode_of_delivery: "Mode de livraison",
        customer_order_status_desc: "Statut de la commande",
        products_manual: "(Qté commandée/Qté expédiée) Produits",
        products: "Produits (quantité commandée)",
        load_nos: "Charger nos",
        received: "Reçu",
        sap_plant: "Carrière",
        delivery_date_from: "Date prévue",
        customer_ref_number: "Bon de commande",
        contract_number: "Numéro de contact",
        truck_number: "Numéro de camion",
        driver_details: "Détails du chauffeur",
        delivery_address: "Adresse de livraison",
        sap_order_failed_message: "Commande en attente",
        special_instructions: "Instruction spécial",
        mode_of_transport: "Mode de transport",
        vehicle_type: "Type de camion",
      },
    },
    change_log: {
      fields: {
        updateBy: "Mis à jour par",
        updated_on: "Date de mise à jour",
        name: "nom",
        email: "E-mail",
        status: "Statut",
        userRole: "Rôle de l'utilisateur",
      },
    },
    track_trems_logs_history: {
      fields: {
        language_name: "Nom de la langue",
        updated_by: "Mis à jour par",
        updated_at: "Date de mise à jour",
      },
    },
    create_business_from_csv: {
      fields: {
        create_business: "Créer une entreprise",
        upload_file: "Télécharger une version",
        file_type: "Le type de fichier doit être .csv",
        file_size: "La taille du fichier doit être inférieure à 10 Mo",
        instruction: "Instructions",
        csv_file: "Seuls les fichiers CSV sont autorisés.",
        file_size_inst: "La taille du fichier doit être inférieure à 2 Mo..",
        wait_msg:
          "Veuillez attendre que le téléchargement du fichier soit terminé et que le message de confirmation apparaisse avant de quitter cette page.",
        result_msg:
          "Vous recevrez les résultats du téléchargement par e-mail indiquant le nombre d'enregistrements ajoutés, mis à jour et échoués (le cas échéant).",
        get_format: "Pour obtenir le format du fichier de téléchargement.",
        click_here: "Cliquez ici",
        to_download: " pour télécharger",
        save: "Enregistrer",
      },
    },
    send_sms_bulk_notifications: {
      fields: {
        message_purpose: "Titre du message",
        enter_purpose: "Veuillez saisir une raison",
        upload_file: "Télécharger une version",
        choose_valid_file: "Choisir un fichier valide",
        instruction: "Instructions :",
        only_csv:
          "Seuls les fichiers CSV sont autorisés avec une virgule comme séparateur.",
        get_format: "Pour obtenir le format du fichier de téléchargement.",
        click_here: "Cliquez ici",
        to_download: " pour télécharger",
        csv_result: "Résultat CSV",
        retailer_found: "revendeurs trouvés,",
        retailer_unregister: "revendeurs non enregistrés.",
        total_cost: "coût total :",
        sold_to_id: "No. Compte client",
        name: "nom",
        message_count: "Nombre de messages",
        description: "Description",
        save: "Enregistrer",
        are_you_sure: "Êtes-vous sûr de vouloir continuer ?",
        cancel: "Annuler",
        ok: "OK",
        success: "Créé avec succès",
        purpose: "Raison",
        target_type: "Cible",
        created_at: "Créé à",
        send_bulk_message: "Envoyer un message groupé",
        details: "DÉTAILS",
        sold_list: "Liste des comptes clients",
        admin_name: "Nom du créateur",
        admin_email: "Courriel du créateur",
        created_at: "Créé à",
        sms_text: "Description",
        targeted_businesses_count: "Nombre de détaillants ciblés",
        notified_businesses_count: "Nombre de commerçants notifiés",
        notification_read_count: "Nombre de revendeurs ayant lu",
        send_status_percent: "% dachèvement",
        name: "Compte client",
        phone: "Numéro de téléphone du compte client",
        send_status: "État SMS",
        send_response: "Réponse SMS",
        job_status: "Progression du message",
        bulk_msg_details: "Détails du message de diffusion en masse",
        uploaded_date_from: "Date téléchargée à partir de",
        uploaded_date_to: "Date téléchargée à",
      },
    },
    my_menu: {
      fields: {
        dashboard: "Tableau de bord",
        admin: "Administration",
        whitelist_user: "Administrateurs",
        terms: "Conditions générales",
        create_business: "Créer des entreprises",
        users: "Utilisateurs",
        sold_to: "Compte client",
        clickit_user: "Utilisateurs",
        digital_order: "Commandes digitales",
        dispute_digital_order: "Commandes digitales refusées",
        received_digital_orders: "Commandes digitales déjà traitées",
        proof_of_payments: "Preuve de paiement",
        proof_records: "Stockage des preuves",
        home_banner: "Bannière d'accueil",
        emailer_banner: "Emailer Banner",
        emailer_banner_list: "Emailer Banner List",
        mobile_banner_list: "Liste de bannières mobiles",
        web_banner_list: "Liste de bannières web",
        product_image: "Image du produit",
        product_inmage_list: "Liste d'images de produits",
        clickit_products: "Produits Clickit",
        holcim_products: "Produits HOLCIM+",
        image_list: "Liste d'images",
        contact_us: "Contactez-nous",
        in_app_message: "Messages In-App",
        bulk_in_app_messages: "Messages de diffusion en masse",
        marketing: "Marketing",
        send_msg: "Envoyer le message",
        send_bulk_message: "Envoyer un message en vrac",
        welcome_msg: "Bienvenue sur le tableau de bord d'administration de Clickit",
        welcome_msg_holcim: "Bienvenue sur le tableau de bord d'administration HOLCIM+",
        notification: "Notification",
        loyalty_points: "Points de fidélité",
        rewards_list: "Liste des récompenses",
      },
    },
    user_loyalty_points: {
      fields: {
        loyalty_points: "Points de fidélité",
        award_redeem_loyalty_points:
          "Attribuer/échanger des points de fidélité",
        select_action: "Sélectionnez une action",
        enter_select_action: "Entrer Sélectionner une action",
        clickit_user: "Utilisateur Clickit",
        holcim_user: "Utilisateur HOLCIM+",
        enter_clickit_user: "Entrez l'utilisateur Clickit",
        enter_holcim_user: "Entrez l'utilisateur HOLCIM+",
        category_for_points_awarded_redeemed:
          "Catégorie pour les points attribués/utilisés",
        comments_for_points_awarded_redeemed:
          "Commentaires sur les points attribués/utilisés",
        points_to_be_awarded_redeemed: "Points à attribuer/échanger",
        enter_valid_points: "Entrez des points valides",
        enter_points_above_zero: "Entrez les points supérieurs à 0",
        enter_points_below_thousand: "Entrez des points inférieurs à 100000",
        enter_category: "Entrez la catégorie",
        enter_category_below_two_hundred_characters:
          "Entrez une catégorie inférieure à 200 caractères",
        enter_comments: "Saisir des commentaires",
        enter_comments_below_five_hundred_characters:
          "Entrez des commentaires inférieurs à 500 caractères",
      },
    },
    loyalty_rewards: {
      fields: {
        rewards_list: "Liste des récompenses",
        create_reward: "Créer une récompense",
        reward: "Récompense",
        enter_reward: "Enter Reward",
        points: "Points",
        enter_valid_points: "Enter Valid Points",
        enter_points_above_zero: "Enter Points Above 0",

        save: "Sauvegarder",
      },
    },
  },
};

export default frenchMessages;
